import { Directive, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

// eslint-disable-next-line @angular-eslint/directive-selector
@Directive({ standalone: true, selector: '[phoneMask]' })
export class PhoneMaskDirective {
    constructor(public ngControl: NgControl) { }

    @HostListener('input', ['$event'])
    onModelChange(event: Event) {
        let newVal = (event.target as HTMLInputElement).value.replace(/\D/g, '');     // remove non-number characters
        if (newVal.length === 0) {
            newVal = '';
        } else if (newVal.length <= 3) {
            newVal = `(${newVal}`;
        } else if (newVal.length <= 6) {
            newVal = `(${newVal.slice(0, 3)}) ${newVal.slice(3)}`;
        } else {
            newVal = `(${newVal.slice(0, 3)}) ${newVal.slice(3, 6)}-${newVal.slice(6, 10)}`;
        }
        this.ngControl.valueAccessor?.writeValue(newVal);        // Set the new value
    }
}
